import { trackYouLeadEvent } from "./analytics/track-event"

;(() => {
  function toggleParamSpecificElements(productInfo, paramName, paramValue) {
    const elements = productInfo.querySelectorAll(`[data-${paramName}]`)

    for (const element of elements) {
      if (element.dataset[paramName] === paramValue) {
        element.style.display = "block"
      } else {
        element.style.display = "none"
      }
    }
  }

  function initProductInfo(productInfo) {
    const colorButtons = productInfo.querySelectorAll('input[name*="color"]')
    const colorLinks = document.querySelectorAll("button[data-color]")
    const moreInfoLink = document.querySelector(".js--more-info-toggler")
    const priceLabel = productInfo.querySelector(".product-info__price")
    const realisationLabel = productInfo.querySelector("#realisation")

    for (const colorLink of colorLinks) {
      colorLink.addEventListener("click", () => {
        toggleParamSpecificElements(
          productInfo,
          "color",
          colorLink.dataset.color,
        )
        trackYouLeadEvent("clickColorLink", `color=${colorLink.dataset.color}`)

        const colorButton = productInfo.querySelector(
          `input[type="radio"][name="color"][value="${colorLink.dataset.color}"]`,
        )
        colorButton.checked = true

        if (priceLabel) {
          priceLabel.textContent = colorButton.dataset.price
        }

        if (realisationLabel) {
          realisationLabel.textContent = colorButton.dataset.realisation
        }
      })
    }

    for (const colorButton of colorButtons) {
      if (colorButton.checked) {
        toggleParamSpecificElements(productInfo, "color", colorButton.value)
      }

      colorButton.addEventListener("change", () => {
        toggleParamSpecificElements(productInfo, "color", colorButton.value)
        trackYouLeadEvent("clickColorButton", `color=${colorButton.value}`)

        if (priceLabel) {
          const span = priceLabel.querySelector("span")

          priceLabel.textContent = colorButton.dataset.price

          if (span) {
            priceLabel.appendChild(span)
          }
        }

        if (realisationLabel) {
          realisationLabel.textContent = colorButton.dataset.realisation
        }
      })
    }

    if (moreInfoLink) {
      moreInfoLink.addEventListener("click", () => {
        moreInfoLink.parentElement.classList.toggle(
          "product-info__more-info--open",
        )
      })
    }

    initFeatureSelect(productInfo)
    initFeatureRadioButtons(productInfo)
  }

  function initFeatureSelect(productInfo) {
    const featureSelect = productInfo.querySelector('select[name="feature"]')

    if (!featureSelect) {
      return
    }

    toggleParamSpecificElements(productInfo, "feature", featureSelect.value)

    featureSelect.addEventListener("change", () => {
      toggleParamSpecificElements(productInfo, "feature", featureSelect.value)
      trackYouLeadEvent("changeFeatureSelect", `feature=${featureSelect.value}`)

      const featureRadioButton = productInfo.querySelector(
        `input[type="radio"][name="feature"][value="${featureSelect.value}"]`,
      )

      if (featureRadioButton) {
        featureRadioButton.checked = true
      }
    })
  }

  function initFeatureRadioButtons(productInfo) {
    const featureRadioButtons = productInfo.querySelectorAll(
      'input[type="radio"][name="feature"]',
    )

    for (const featureButton of featureRadioButtons) {
      if (featureButton.checked) {
        toggleParamSpecificElements(productInfo, "feature", featureButton.value)
      }

      featureButton.addEventListener("change", () => {
        toggleParamSpecificElements(productInfo, "feature", featureButton.value)
        trackYouLeadEvent(
          "changeFeatureButton",
          `feature=${featureButton.value}`,
        )

        const featureSelect = productInfo.querySelector(
          'select[name="feature"]',
        )

        if (featureSelect) {
          featureSelect.value = featureButton.value
        }
      })
    }
  }

  function toggleFeatureFormElement() {
    const featureSelect = document.querySelector('select[name="feature"]')
    const featureRadios = document.querySelectorAll('input[name="feature"]')

    if (!featureSelect || featureRadios.length === 0) {
      return
    }

    const isMobile = window.innerWidth < 768

    featureSelect.disabled = isMobile

    for (const radio of featureRadios) {
      radio.disabled = !isMobile
    }
  }

  window.addEventListener("load", () => {
    for (const productInfo of document.querySelectorAll(".js--product-info")) {
      initProductInfo(productInfo)
    }

    toggleFeatureFormElement()

    window.addEventListener("resize", toggleFeatureFormElement)
  })
})()
